const { Fragment } = wp.element;

function Video({ attributes }) {
  const { protected: bProtected, provider = "library", source = "", poster = "", preload = "metadata", protectedText } = attributes;
  return (
    <div>
      {!bProtected ? (
        <Fragment>
          {provider === "library" && (
            <>
              <h3>Nothing to hide</h3>
              <video controls playsinline data-poster={poster} preload={preload}>
                <source src={source} type="video/mp4" />
              </video>
            </>
          )}
          {provider === "youtube" && <div className="notlibrary" data-plyr-provider="youtube" data-plyr-embed-id={source}></div>}
          {provider === "vimeo" && <div className="notlibrary" data-plyr-provider="vimeo" data-plyr-embed-id={source}></div>}
        </Fragment>
      ) : (
        <Fragment>
          <div className="video_overlay"></div>
          <div className="password_form">
            <form action="#">
              <label for="password">{protectedText}</label>
              <br />
              <input type="password" id="password" placeholder="Password" />
              <br />
              <input type="submit" value="Access Video" />
              <p className="notice"></p>
            </form>
          </div>
          {provider === "library" && <video playsinline className="player" poster={poster} />}
        </Fragment>
      )}
    </div>
  );
}

export default Video;
